import { version } from "pdfjs-dist";

export const PDFJS_WORKER_URL = `https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;
